/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class StudentPops extends SubCatAccordion implements IsubCatAccordion
    {   
        typeCbs = [{ type: "< 2,500", isChecked: false },
            { type: "2,501 - 5,000", isChecked: false },
            { type: "5,001 - 10,000", isChecked: false },
            { type: "10,001 - 15,000", isChecked: false },
            { type: "15,001 - 20,000", isChecked: false },
            { type: "> 20,000", isChecked: false }
        ];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }
    }
}